module.exports = __webpack_public_path__ + "img/boxed-2.220f0423.png";